module.exports = __webpack_public_path__ + "img/projectList_bg6.e219c7f1.png";